import React, { useState } from 'react';
import IconButton from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/IconButton';
import MenuIcon from 'housecall-ui/dist/IconsAndImages/Icons/Menu';
import PropTypes from 'prop-types';

import HamburgerDrawer from './HamburgerDrawer';

function HamburgerMenu({ activeTab, toolbarTabs, packageLogo }) {
  const [open, setToggle] = useState(false);
  const toggleDrawer = () => setToggle(!open);

  return (
    <>
      <IconButton edge="start" version="v2" onClick={toggleDrawer}>
        <MenuIcon />
      </IconButton>
      <HamburgerDrawer
        open={open}
        activeTab={activeTab}
        onCloseClick={toggleDrawer}
        toolbarTabs={toolbarTabs}
        packageLogo={packageLogo}
      />
    </>
  );
}

HamburgerMenu.propTypes = {
  activeTab: PropTypes.string,
  toolbarTabs: PropTypes.arrayOf(PropTypes.object),
  packageLogo: PropTypes.element,
};

export default HamburgerMenu;
